// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyC4smWzPXkeJbpXDKxeZ1Q2bwHRz84W3uI",
  authDomain: "stockmarket-83a73.firebaseapp.com",
  projectId: "stockmarket-83a73",
  storageBucket: "stockmarket-83a73.firebasestorage.app",
  messagingSenderId: "808005808547",
  appId: "1:808005808547:web:5dfa2df504347d6d5fea16"
};


const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);